module.exports = __webpack_public_path__ + "static/media/500WS-small.a8ae5757.svg";